import React from 'react';
import { trackPhoneCall } from '@/lib/gtag';
import { Phone } from 'lucide-react';

const UrgentServices = () => {
  return (
    <section className="bg-gradient-to-r from-[#2563eb] via-[#1e40af] to-[#2563eb] text-white py-3 md:py-4 shadow-lg relative overflow-hidden">
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row items-center justify-center md:justify-between gap-3 w-full">
          {/* Título Principal */}
          <div className="text-center md:text-left flex-shrink-0">
            <h2 className="text-base sm:text-lg md:text-xl font-bold mb-1">
              URGÊNCIA
            </h2>
            <p className="text-xs sm:text-sm md:text-base font-semibold text-white">
              CHEGAMOS RAPIDAMENTE
            </p>
          </div>

          {/* Espaçador para desktop */}
          <div className="hidden md:block flex-1"></div>

          {/* Botão de Ligar */}
          <a
            href="tel:+351960488777"
            className="bg-primary hover:bg-primary-dark text-white font-bold py-2 px-4 md:py-2 md:px-5 rounded-full transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl flex items-center gap-2 whitespace-nowrap text-xs sm:text-sm md:text-base flex-shrink-0"
            onClick={() => trackPhoneCall('+351960488777')}
          >
            <Phone className="w-4 h-4 md:w-5 md:h-5 fill-current" />
            <span>LIGAR AGORA</span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default UrgentServices;

